var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/draft-modal.scss";
import { useSelector } from "react-redux";
import ProductBouquetTable from "@frameworks/NCD/pages/ProductBouquet/Components/ProductBouquetTable";
import { useProductName } from "@frameworks/NCD/Hook/Draft/useProductName";
import useTransactionHandler from "@frameworks/NCD/Hook/TabContent/useTransactionHandler";
import generateProductBouquetTableColumns from "../../../../ProductBouquet/Components/TabContent/tableColumns";
import transactionJourneyActions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import useDraftOrdersList from "@frameworks/NCD/Hook/Draft/useDraftOrdersList";
var DraftOrders = function () {
    var _a, _b;
    var _c = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), draftOrderCount = _c.draftOrderCount, draftOrders = _c.draftOrders;
    var draftOrdersRequestPayload = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).draftOrdersRequestPayload;
    var draftLoader = useDraftOrdersList().loader;
    var handleTransactionClick = useTransactionHandler().handleTransactionClick;
    var cTransactionJourneyActions = new transactionJourneyActions();
    var handleSortChange = function (value) {
        var newPayload = __assign(__assign({}, draftOrdersRequestPayload), { page_index: 1, page_size: 10, orderby: value === null || value === void 0 ? void 0 : value.sortKey, orderbydesc: !(draftOrdersRequestPayload === null || draftOrdersRequestPayload === void 0 ? void 0 : draftOrdersRequestPayload.orderbydesc) });
        cTransactionJourneyActions.updateDraftOrdersRequestPayload(newPayload);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "draft-order-container" },
            React.createElement("p", { className: "title DMSan_28_400 txt-midnight-blue fw-400" },
                "Draft Orders (", (_a = draftOrderCount === null || draftOrderCount === void 0 ? void 0 : draftOrderCount.data) === null || _a === void 0 ? void 0 :
                _a.count,
                ")"),
            React.createElement("p", { className: "subtitle DMSan_16_400 txt-grey-shade1 fw-400" }, "Pick up where you left off and complete your order placement."),
            React.createElement("div", { className: "alert-container" },
                React.createElement("i", { className: "edel-icon-attention-icon lh-22-4", style: { fontSize: 22 } }),
                React.createElement("p", { className: "DMSanN_14_400 fw-400" }, "Drafted orders stay active for 30 days from the last update and expire automatically afterward.")),
            React.createElement("p", { className: "heading DMSan_26_700 txt-midnight-blue-shade2 fw-bold" }, useProductName())),
        React.createElement(ProductBouquetTable, { columns: generateProductBouquetTableColumns({
                id: "otc",
                handleTransactionClick: handleTransactionClick,
                isBookmarkFunctionality: false,
            }), data: draftOrders === null || draftOrders === void 0 ? void 0 : draftOrders.data, totalItems: (_b = draftOrderCount === null || draftOrderCount === void 0 ? void 0 : draftOrderCount.data) === null || _b === void 0 ? void 0 : _b.count, searchFilterApplied: false, parentClassName: "draft-table", isBookmarkFunctionality: false, paginationButtonCallback: function (payload) {
                cTransactionJourneyActions.updateDraftOrdersRequestPayload(payload);
            }, showShimmer: draftLoader, payloadData: draftOrdersRequestPayload, callbackSorted: handleSortChange, tryAgainButtonCallback: function () {
                return cTransactionJourneyActions.updateDraftOrdersRequestPayload(__assign({}, draftOrdersRequestPayload));
            } })));
};
export default DraftOrders;
